
import React, {
    useEffect,
    useRef,
    useState,
    useImperativeHandle,
    forwardRef,
} from "react";
import { gsap } from "gsap";
import "./GangSterBonusAnimate.scss";

import box_base from "../../../../../../assets/games/slots/Gangster_Party/box.webp";
import lid_open from "../../../../../../assets/games/slots/Gangster_Party/bonusBox_open_shine.webp";
import lid_open_fail from "../../../../../../assets/games/slots/Gangster_Party/bonusBox_open.webp";

import profile from '../../../../../../assets/games/slots/CommanAssets/userid.png';
import win from "../../../../../../assets/games/slots/CommanAssets/win_icon.png"
import balance from "../../../../../../assets/games/slots/CommanAssets/coins_bln.png"


import confetti from "canvas-confetti";
import Howlersounds from "../../../../Utillitys/slotshowlersounds";

const TreasureBoxGame = forwardRef(
    ({ BonusBoxGameClosepopup, BonusActiveCall, muteSoundStatus, balanceGSP, userName, responseData }, ref) => {
        const howlerRef = useRef(null);

        const BOX_COUNT = 5;
        const BoxesCount = Array.from({ length: BOX_COUNT }, (_, i) => i);

        // REFS (eslint-safe)
        const boxRef = useRef([]);
        const lidRef = useRef([]);
        const openLidRef = useRef([]);

        const clickedBoxRef = useRef(null);
        const totalWinRef = useRef(0);

        const msgRef = useRef(null);
        const amountRef = useRef(null);
        const amountRefAnimate = useRef(null);
        const grandLightRef = useRef(null);

        const [boxResults, setBoxResults] = useState({});
        const [openedBoxes, setOpenedBoxes] = useState([])
        const [waitingForResponse, setWaitingForResponse] = useState(false);
        const [isGameOver, setIsGameOver] = useState(false);
        const [winAmountBonus, setWinAmount] = useState();
        const [winAmountBonusBox, setWinAmountBox] = useState(0);
        const [entryAnimationDone, setEntryAnimationDone] = useState(false);

        /* ---------------------------------------------------
           ENTRY DROP ANIMATION (ONE BY ONE)
        --------------------------------------------------- */
        useEffect(() => {
            console.log(responseData)
            if (!responseData) return;
            const { bonusSelectIndex, bonusWinAmount, gameFinished} = responseData;

            if (!bonusSelectIndex || bonusSelectIndex.length === 0 || gameFinished) return;

            // restore total win
            totalWinRef.current = bonusWinAmount || 0;
            setWinAmount(bonusWinAmount || 0);

            // restore opened boxes state
            setOpenedBoxes(bonusSelectIndex);

            // animate already opened boxes
            bonusSelectIndex.forEach((index, i) => {

                const lid = lidRef.current[index];
                const openLid = openLidRef.current[index];

                if (!lid || !openLid) return;

                gsap.delayedCall(i * 0.2, () => {

                    gsap.set(lid, { opacity: 0 });
                    gsap.set(openLid, {
                        opacity: 1,
                        scale: 1.05
                    });

                });
            });

            // show win animation again if already won something
            if (bonusWinAmount > 0) {
                runGrandLighting();
                animateAmountCenter();
            }

        }, [responseData]);



        useEffect(() => {
            setEntryAnimationDone(false);

            const tl = gsap.timeline({
                onComplete: () => setEntryAnimationDone(true),
            });

            boxRef.current.forEach((box, index) => {
                if (!box) return;

                gsap.set(box, {
                    y: -350,
                    scale: 0.85,
                    opacity: 0,
                });

                tl.to(
                    box,
                    {
                        y: 0,
                        scale: 1,
                        opacity: 1,
                        duration: 1,
                        ease: "bounce.out",
                        onStart: () => tableImpactEffect(box),
                    },
                    index * 0.4
                );
            });

            return () => tl.kill();
        }, []);

        /* ---------------------------------------------------
           TABLE IMPACT EFFECT
        --------------------------------------------------- */
        const tableImpactEffect = (box) => {
            gsap.fromTo(
                box,
                { filter: "drop-shadow(0 0 0px gold)" },
                {
                    filter: "drop-shadow(0 0 20px gold)",
                    duration: 0.15,
                    yoyo: true,
                    repeat: 1,
                }
            );
        };

        /* ---------------------------------------------------
           BOX SHAKE
        --------------------------------------------------- */
        const animateShake = (el) => {
            gsap.fromTo(
                el,
                { x: 0 },
                {
                    x: "+=6",
                    duration: 0.02,
                    repeat: 15,
                    yoyo: true,
                }
            );
        };

        /* ---------------------------------------------------
           CLICK HANDLER
        --------------------------------------------------- */
        const handleClick = (index) => {
            if (!entryAnimationDone) return;
            if (isGameOver) return;
            if (waitingForResponse) return;

            if (openedBoxes.includes(index)) return;
            howlerRef.current?.playSound("bonusStart");

            clickedBoxRef.current = index;
            setWaitingForResponse(true);

            animateShake(boxRef.current[index]);
            BonusActiveCall(index);
        };

        /* ---------------------------------------------------
           SERVER RESPONSE
        --------------------------------------------------- */
        useImperativeHandle(ref, () => ({
            WinsBonusBoxOpen(winAmount,TotalWinAmount) {
                const index = clickedBoxRef.current;
                const isWinner = Number(winAmount) > 0;

                setBoxResults(prev => ({
                        ...prev,
                        [index]: winAmount
                    }));

                // OPEN BOX
                gsap.to(lidRef.current[index], { opacity: 0, duration: 0.3 });
                gsap.to(openLidRef.current[index], {
                    opacity: 1,
                    scale: 1.1,
                    duration: 0.5,
                });

                setOpenedBoxes((prev) => [...prev, index]);

                if (isWinner) {
                    // 💰 WIN
                    setWinAmountBox(winAmount)
                    setTimeout(()=>{
                        // totalWinRef.current += Number(winAmount);
                        totalWinRef.current = Number(TotalWinAmount);
                        setWinAmount(totalWinRef.current);
                    },1000)

                    runGrandLighting();
                    animateAmountCenter();
                    burstEffect();

                    setWaitingForResponse(false);
                } else {
                    // 💣 BOMB
                    setIsGameOver(true);

                    gsap.to(msgRef.current, {
                        opacity: 1,
                        y: -20,
                        duration: 1,
                    });

                    setTimeout(() => {
                        confetti.reset();
                        gsap.killTweensOf("*");
                        BonusBoxGameClosepopup(false);
                    }, 2500);
                }
            },
        }));

        /* ---------------------------------------------------
           CENTER WIN AMOUNT ANIMATION
        --------------------------------------------------- */
        const animateAmountCenter = () => {
            gsap.killTweensOf(amountRef.current);

            gsap.set(amountRef.current, {
                x: "50%",
                y: "50%",
                xPercent: -50,
                yPercent: -50,
                scale: 0.8,
                opacity: 0,
            });

            gsap.to(amountRef.current, {
                opacity: 1,
                scale: 1.2,
                duration: 0.5,
                ease: "back.out(1.8)",
            });

            gsap.to(amountRef.current, {
                scale: 1,
                repeat: -1,
                yoyo: true,
                duration: 0.9,
                ease: "power1.inOut",
            });

            gsap.to(amountRefAnimate, {
                yPercent: 0,
                opacity: 0,
                ease: "power2.out",
            });
            animateAmountBoxs(clickedBoxRef.current)
            console.log(clickedBoxRef.current)
        };



        const animateAmountBoxs = () => {
            gsap.killTweensOf(amountRefAnimate.current);

             const OFFSET_MAP = [-40,-20,0, 15, 40];
            const amountEl = amountRefAnimate.current;
            gsap.set(amountEl, {
                opacity: 0,
                scale: 0.3,
                xPercent: (OFFSET_MAP[Number(clickedBoxRef.current)]),
                // xPercent: (Number(clickedBoxRef.current) - 2) * 15,
            });

            // ⭐ COIN EXPLOSION STYLE
            gsap.to(amountEl, {
                // delay: 0.4,
                // opacity: 1,
                scale: 1.4,
                duration: 0.45,
                ease: "back.out(1.7)",
            });

            // ⭐ Move to top center
            gsap.to(amountEl, {
                delay: 0.45,
                yPercent: -40,
                xPercent: 0,
                opacity: 1,
                scale: 1.5,
                duration: 1,
                ease: "power2.out",
            });
               gsap.to(amountEl, {
                 delay: 1,
                 opacity: 0,
                 ease: "power2.out",
               })

            // ⭐ Glow pulse
            gsap.to(amountEl, {
                textShadow: "0 0 30px gold",
                repeat: -1,
                yoyo: true,
                duration: 0.9,
            });

            gsap.to(amountEl, {
                yPercent: 0,
                opacity: 0,
                duration: 0.5,
                ease: "power2.out",
            });
        };

        /* ---------------------------------------------------
           GRAND LIGHT
        --------------------------------------------------- */
        const runGrandLighting = () => {
            gsap.set(grandLightRef.current, { opacity: 0, scale: 0.2 });

            gsap.to(grandLightRef.current, {
                opacity: 1,
                scale: 1.4,
                duration: 0.6,
            });

            gsap.to(grandLightRef.current, {
                rotate: 360,
                repeat: -1,
                duration: 3,
                ease: "linear",
            });
        };

        /* ---------------------------------------------------
           CONFETTI
        --------------------------------------------------- */
        const burstEffect = () => {
            howlerRef.current?.playSound("bonusWin");

            confetti({
                particleCount: 200,
                spread: 160,
                origin: { y: 0.7 },
            });
        };

        /* ---------------------------------------------------
           JSX
        --------------------------------------------------- */
        return (
            <>
                <Howlersounds ref={howlerRef} mutesounds={muteSoundStatus} />

                <div className="main_div_Bonus">
                    <div>
                        <div className="balance_winDivGSP">
                            <div className="text-center balance_section BGM_GSP_profileBar">
                                <img src={balance} alt="" className="imgbtnCT upsectionCT" />
                                <p className="amt_numCT">{balanceGSP.toFixed(2)}</p>
                            </div>
                            <div></div>
                            <div className="btwn_space_bln">
                                <div className="text-center balance_section BGM_GSP_profileBar">
                                    <img src={win} alt="" className="imgbtnCT upsectionCT" />
                                    <p className="amt_numCT">{winAmountBonus}</p>
                                </div>
                                <div className="text-center balance_section BGM_GSP_profileBar">
                                    <img src={profile} alt="" className="imgbtnCT upsectionCT" />
                                    <p className="amt_numCT">{userName}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="gameWrapper gangster-table">
                        <div ref={grandLightRef} className="grand-light" />
                        <div class="smoke-container">
                            <span class="smoke s1"></span>
                            <span class="smoke s2"></span>
                            <span class="smoke s3"></span>
                        </div>
                        <div class="coin-shine"></div>
                        <div class="coin-shine coin-shine_left"></div>
                        <div class="coin-shine coin-shine_pen"></div>

                        <div ref={amountRef} className="amount-text">
                            {winAmountBonus}
                        </div>

                        <div ref={amountRefAnimate} className="amount-text_animate">
                            {winAmountBonusBox}
                        </div>

                        <div ref={msgRef} className="lose-text">
                            💣 BOOM!
                        </div>

                        <div className="table-area">
                            <div className="box-row">
                                {BoxesCount.map((i) => (
                                    <div
                                        key={i}
                                        ref={(el) => (boxRef.current[i] = el)}
                                        className={`box-wrap ${openedBoxes.includes(i) ? "opened" : ""
                                            }`}
                                        onClick={() => handleClick(i)}
                                    >
                                        <img
                                            ref={(el) => (lidRef.current[i] = el)}
                                            src={box_base}
                                            className="box-img"
                                        />
                                        <img
                                            ref={(el) => (openLidRef.current[i] = el)}
                                            src={boxResults[i] > 0 ? lid_open : lid_open_fail}
                                            className="open-lid-img"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* <div className="select_one_div">
                            <h2>Pick a Suitcase 💼 </h2>
                            <p>💰 Keep winning until you hit the 💣</p>
                        </div> */}
                        <div className="select_one_div">
                            <svg
                                className="arc-title"
                                width="400"
                                height="360"
                                viewBox="0 0 400 1"
                            >
                                <defs>
                                    <path
                                        id="arcPath"
                                        d="M 30 90 A 150 150 0 0 1 330 90"
                                    />
                                </defs>

                                <text className="arc-text">
                                    <textPath
                                        href="#arcPath"
                                        startOffset="52%"
                                        textAnchor="middle"
                                    >
                                        Pick a Suitcase 💼
                                    </textPath>
                                </text>
                            </svg>

                            <p>💰 Keep winning until you hit the 💣</p>
                        </div>

                    </div>
                </div>
            </>
        );
    }
);

export default TreasureBoxGame;








